import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Alert,
  Typography,
  Button,
  CircularProgress,
} from '@mui/material';

export default function OperationModal({
  open,
  setIsModalOpen,
  onSubmit,
  canSubmit,
  setFormValues,
  defaultValues,
  operation,
  children,
  maxWidth,
}) {
  if (!maxWidth) maxWidth = 'sm';
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const isSubmitable = () => {
    return canSubmit && !loading;
  };
  const handleErrors = (err) => {
    setError(err);
  };
  const handleClose = () => {
    setFormValues(defaultValues);
    setIsModalOpen(false);
    setLoading(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    operation()
      .then(() => {
        setLoading(false);
        setIsModalOpen(false);
        setFormValues(defaultValues);
        onSubmit();
      })
      .catch(() => {
        setLoading(false);
        handleErrors(
          <Alert variant="filled" severity="error" sx={{ marginBottom: 3 }}>
            <Typography variant="caption">
              We are unable to reflect the changes in your contact channels. Please contact the
              administrator at webteam@msuiit.edu.ph.
            </Typography>
          </Alert>
        );
      });
  };
  return (
    <Dialog open={open} scroll={'paper'} onClose={handleClose} aria-labelledby="add-exam-title">
      <DialogContent
        sx={{
          overflowY: 'visible',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '30px',
          padding: '70px 50px',
          background: '#FFFFEA',
        }}
      >
        {error}
        {children}
      </DialogContent>
      <DialogActions
        sx={{
          background: '#FFFFEA',
        }}
      >
        <Button variant="contained" size="large" color="error" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
          disabled={!isSubmitable()}
        >
          Submit
        </Button>
        {loading && (
          <CircularProgress
            size={24}
            color={'success'}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
      </DialogActions>
    </Dialog>
  );
}

OperationModal.propTypes = {
  open: PropTypes.bool,
  canSubmit: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
  onSubmit: PropTypes.func,
  setFormValues: PropTypes.func,
  defaultValues: PropTypes.object,
  operation: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  maxWidth: PropTypes.string,
};
